export default {
  exceptionType: 'Exception Type',
  emailEvent: 'Email Event',
  emailEventStatus: 'Email Event Status',
  emailReceiver: 'Email Receiver',
  emailSendStatus: 'Email Send Status',
  email: 'Email',
  systemName: 'System Name',
  lastSendTime: 'Last Send Time',
  addOrEdit: 'Add/Remove Receiver',
  disabledEmailDataTip: 'Are you sure to disable this email event?',
  enableEmailDataTip: 'Are you sure to enable this email event?',
  error_3001: 'Please input correct user email address.',
  error_3002: 'This receiver already exist in the system.',
  showOpt: 'Display Operation Column'
}
